/** Cross-cutting limits and defaults. Infra enforces these too — keep in sync. */

export const PAGINATION = {
  defaultLimit: 25,
  maxLimit: 100,
} as const;

export const UPLOAD_LIMITS = {
  /** 25 MB — photos and documents from the field. */
  maxFileBytes: 25 * 1024 * 1024,
  /** Presigned PUT/GET validity. */
  presignedUrlTtlSeconds: 300,
  allowedMimeTypes: [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'application/pdf',
    'video/mp4',
  ] as const,
} as const;

export const AI_LIMITS = {
  /** Below this the interpretation is always kept as PROPOSED for review. */
  autoConfirmConfidenceThreshold: 0.9,
  maxInputChars: 8000,
  maxOutputTokens: 2048,
  maxRepairAttempts: 1,
} as const;

export const ATTENTION_RULES = {
  /** Days without an update before an activity is flagged as stale. */
  staleAfterDays: 3,
  /** Days ahead a milestone is considered "upcoming". */
  upcomingMilestoneWindowDays: 45,
  /** Days ahead a due date starts being called out in lists. */
  dueSoonWindowDays: 7,
} as const;

/** Header used to carry the active organization when a user belongs to several. */
export const TENANT_HEADER = 'x-kainos-tenant';
export const REQUEST_ID_HEADER = 'x-request-id';
